export default __webpack_public_path__ + "static/media/api.fb3b32d5.svg";